import moment from 'moment';
import * as devisConf from '@/configuration/devisConf';

export default function calculDateFin(dateDebut, quantite, uniteDeTemps) {
  if (quantite <= 0 || !dateDebut) {
    return null;
  }
  const dateStart = moment(dateDebut);
  let unit = '';
  switch (uniteDeTemps) {
    case devisConf.JOUR:
      unit = 'days';
      break;
    case devisConf.SEMAINE:
      unit = 'weeks';
      break;
    case devisConf.MOIS:
      unit = 'months';
      break;
    case devisConf.ANNEE:
      unit = 'years';
      break;
    default:
      return null;
  }
  return dateStart.clone().add(quantite, unit).add(-1, 'days').toDate();
}
